module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/hidden-keys.js
// module id = 89
// module chunks = 0 1